// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 297) return "static/chunks/mui-9f531001114c73b8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"96":"aebcdaa71235b476","487":"54dd816bca2e1673","558":"0e2f44c174cb32e4"}[chunkId] + ".js";
};